import { InputProps } from '@mui/material';
import SearchField from 'components/Layout/SearchField';
import { markets } from 'constants/markets';
import { useOrganisationPersonalWebshop } from 'hooks/useOrganisationPersonalWebshop';
import { useRouter } from 'next/router';
import { useState, ChangeEvent, SyntheticEvent } from 'react';
import useSearch from 'stores/useSearch';
import { colors } from 'styles/theme/colors';
import useMarket from 'stores/useMarket';
import { useNavigation } from '../../../../../hooks/useNavigation';

type DesktopProductSearchFieldProps = InputProps;

export default function DesktopProductSearchField({ ...props }:DesktopProductSearchFieldProps) {
    const router = useRouter();
    const market = useMarket((state) => state.market);
    const { setSearchValue } = useSearch();
    // @todo Urlencode searchFieldValue, urldecode on search page
    const [searchFieldValue, setSearchFieldValue] = useState('');
    function handleInputChange(event: ChangeEvent<HTMLInputElement>) {
        setSearchFieldValue(event.target.value);
    }

    const { shop } = useNavigation();

    function handleReroute<T extends SyntheticEvent>(event: T): void {
        event.preventDefault();
        router.push(
            `/catalogsearch/result/${searchFieldValue}`,
            `/catalogsearch/result/${searchFieldValue}`,
            { locale: markets[market].locale },
        );
    }

    function handleSearchFieldClear() {
        setSearchValue('');
        setSearchFieldValue('');
    }

    return (
        <SearchField
            handleInputChange={handleInputChange}
            handleSearchFieldClear={handleSearchFieldClear}
            handleOnClickSearch={(event) => {
                handleReroute(event);
                handleSearchFieldClear();
            }}
            searchFieldValue={searchFieldValue}
            formControlSx={{
                paddingBottom: 3,
                paddingRight: 3,
            }}
            inputProps={{
                ...props,
                sx: {
                    backgroundColor: colors.white,
                    '& input::placeholder': { color: colors.pink2, opacity: 1 },
                    borderColor: colors.pink2,
                    borderBottom: '1px solid',
                    paddingLeft: 1,
                    marginLeft: 0,
                    fontWeight: 400,
                    fontSize: '16px',
                    justifySelf: 'flex-end',
                    marginX: 0,
                    paddingBottom: 0,
                    ...props.sx,
                },
            }}
        />
    );
}
